/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActionButton/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import GenerateLetter from './GenerateLetter/index'
import No from './No/index'
import React from 'react'
import Review from './Review/index'



/** @type {import('Simple/types.js').View} */
export default function ActionButton({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/OldAction/Action/ActionButton"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let actionTypeValueData = fromData.useDataFormat({ viewPath,
context: 'action',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: actionTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'GenerateLetter'}>
<GenerateLetter
  viewPath={`${viewPath}/GenerateLetter`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Review'}>
<Review
  viewPath={`${viewPath}/Review`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}